import axios from "axios";
console.log("process", process.env.VUE_APP_JSON_CDN_DOMAIN);
const instance = axios.create({
  baseURL: process.env.VUE_APP_JSON_CDN_DOMAIN,
  timeout: 15000,
});

export default instance;
